import styled from 'styled-components'

export const IconWrapper = styled.span`
  cursor: pointer;
  font-size: 18px;
  color: #1890ff;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #40a9ff;
  }
`

export const CommentContent = styled.div`
  max-width: 400px;
  max-height: 200px;
  overflow-y: auto;
  color: #fff;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
`

export const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 5px 0 4px;
`

